var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 7.5625L16 5.96875V1.5C16 1.25 15.75 1 15.5 1H12.5C12.2188 1 12 1.25 12 1.5V2.46875L9.3125 0.125C9.25 0.0625 9.09375 0.03125 9 0.03125C8.875 0.03125 8.71875 0.0625 8.65625 0.125L0.15625 7.5625C0.0625 7.65625 0 7.84375 0 7.96875C0 8.21875 0.21875 8.46875 0.5 8.46875C0.59375 8.46875 0.75 8.40625 0.8125 8.34375L2 7.3125V14.5C2 15.3438 2.65625 16 3.5 16H14.5C15.3125 16 15.9688 15.3438 16 14.5V7.3125L17.1562 8.34375C17.2188 8.40625 17.375 8.4375 17.4688 8.4375C17.75 8.4375 17.9688 8.21875 17.9688 7.9375C17.9688 7.8125 17.9062 7.65625 17.8125 7.5625ZM15 14.5C15 14.7812 14.75 15 14.5 15H3.5C3.21875 15 3 14.7812 3 14.5V6.4375L9 1.1875L15 6.4375V14.5ZM15 5.09375L13 3.34375V2H15V5.09375ZM6.5 6.84375V10.1875C6.5 10.6562 6.84375 11 7.3125 11H10.6562C11.0938 11 11.4688 10.6562 11.5 10.1875V6.84375C11.4688 6.375 11.0938 6.03125 10.6562 6H7.3125C6.84375 6.03125 6.5 6.375 6.5 6.84375ZM7.5 7H10.5V10H7.5V7Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.ee19c591.svg";
export { ForwardRef as ReactComponent };